// La card de un modo que todavía no existe ("Próximamente"). Vivía en `HomeMinimal`; salió
// a su archivo cuando el panel de Catálogo de la sidebar pasó a dibujar las mismas cards
// (ADR-2026-10-05-los-paneles-de-la-sidebar-con-las-cards-de-la-home).

import { Play } from 'lucide-react';

/**
 * Un modo que todavía no existe, en la grilla del popup. Misma anatomía que las cards
 * de `GrillaDeModos` (carátula 3:2, nombre y bajada debajo) para que se lea como una
 * herramienta más de la sección, pero sin click: no hay pantalla a la que ir.
 *
 * La carátula es DIBUJADA —un cuadro vertical con play sobre el tinte de la sección—
 * porque no hay resultados todavía; la pastilla "Próximamente" va donde las cards
 * bloqueadas llevan "Ver ejemplos".
 */
export function CardModoProximo({ nombre, bajada }: { nombre: string; bajada: string }) {
  return (
    <div
      aria-disabled="true"
      className="overflow-hidden rounded-xl border border-black/[0.06] text-left"
    >
      <span className="relative grid aspect-[3/2] place-items-center bg-[#F4F1E6]">
        <span
          aria-hidden="true"
          className="grid aspect-[9/16] h-[62%] place-items-center rounded-lg bg-white/80 text-black/35 shadow-[0_6px_18px_rgba(16,24,45,0.10)]"
        >
          <Play className="ml-0.5 h-5 w-5 fill-current" />
        </span>
        <span className="absolute bottom-2.5 right-2.5 inline-flex items-center rounded-full bg-white/90 px-3 py-1.5 text-[12px] font-bold text-brand-black shadow-lg backdrop-blur">
          Próximamente
        </span>
      </span>
      <span className="block px-3.5 py-3">
        <span className="block truncate text-[14px] font-semibold text-brand-black/90">
          {nombre}
        </span>
        <span className="mt-0.5 block truncate text-[12.5px] leading-snug text-black/50">
          {bajada}
        </span>
      </span>
    </div>
  );
}

